export const LIST_EMPTY_TITLE_KEYWORDS = ['&nbsp;', 'null'];
